export const UPDATE_CREDIT_CARD_FILTER_FORM_DATA =
  "UPDATE_CREDIT_CARD_FILTER_FORM_DATA";
export const updateCreditCardFilterFormData = formData => ({
  type: UPDATE_CREDIT_CARD_FILTER_FORM_DATA,
  formData
});

export const CLEAR_CREDIT_CARD_FILTER_FORM_DATA =
  "CLEAR_CREDIT_CARD_FILTER_FORM_DATA";
export const clearCreditCardFilterFormData = () => ({
  type: CLEAR_CREDIT_CARD_FILTER_FORM_DATA
});
